import { useExpressionValue } from '../../../../expressions/render/hooks/useExpressionValue';
import { ISwitchExpression } from '../../../../expressions/repository/switch-expression/ISwitchExpression';

export function useSwitchExpressionValue(
  name: string,
  expression: ISwitchExpression,
) {
  const expressionValue = useExpressionValue(name, expression, {});

  return expressionValue.type === 'value' ? expressionValue.result : null;
}
